import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Dialogo generico per le azioni del SAL che richiedono valori o un motivo
export const PromptDialog = ({ p, onClose }) => {
  const [v, setV] = useState(Object.fromEntries((p.fields || []).map((f) => [f.k, f.init ?? ""])));
  const [busy, setBusy] = useState(false);
  const ok = (p.fields || []).every((f) => f.optional || String(v[f.k]).trim() !== "");
  const conferma = async () => { setBusy(true); const done = await p.onSubmit(v); setBusy(false); if (done) onClose(); };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="sal-prompt-dialog">
        <DialogHeader><DialogTitle>{p.title}</DialogTitle>{p.description && <DialogDescription>{p.description}</DialogDescription>}</DialogHeader>
        <div className="space-y-3">{(p.fields || []).map((f) => (
          <div key={f.k} className="space-y-1"><Label className="text-xs">{f.label}</Label>
            <Input type={f.type || "text"} step="any" value={v[f.k]} onChange={(e) => setV((o) => ({ ...o, [f.k]: e.target.value }))} data-testid={`prompt-${f.k}`} /></div>))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="prompt-annulla">Annulla</Button>
          <Button onClick={conferma} disabled={!ok || busy} className={p.danger ? "bg-rose-600 hover:bg-rose-700" : ""} data-testid="prompt-conferma">{p.confirm || "Conferma"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
